import { Room } from "./types";

export function getRooms(): Room[] {
  return [
    {
      roomId: 37368,
      roomIdHex: "0x91F8",
      handle: "landingSite",
      name: "Landing Site",
      area: 0,
      areaName: "Crateria",
      mapX: 23,
      mapY: 0,
      widthScreens: 9,
      heightScreens: 5,
    },
    {
      roomId: 37555,
      roomIdHex: "0x92B3",
      handle: "gauntletEntrance",
      name: "Gauntlet Entrance",
      area: 0,
      areaName: "Crateria",
      mapX: 18,
      mapY: 2,
      widthScreens: 5,
      heightScreens: 1,
    },
    {
      roomId: 37629,
      roomIdHex: "0x92FD",
      handle: "parlorAndAlcatraz",
      name: "Parlor and Alcatraz",
      area: 0,
      areaName: "Crateria",
      mapX: 18,
      mapY: 4,
      widthScreens: 5,
      heightScreens: 5,
    },
    {
      roomId: 37802,
      roomIdHex: "0x93AA",
      handle: "crateriaPowerBombRoom",
      name: "Crateria Power Bomb Room",
      area: 0,
      areaName: "Crateria",
      mapX: 32,
      mapY: 1,
      widthScreens: 2,
      heightScreens: 1,
    },
    {
      roomId: 37845,
      roomIdHex: "0x93D5",
      handle: "crateriaSaveRoom",
      name: "Crateria Save Room",
      area: 0,
      areaName: "Crateria",
      mapX: 18,
      mapY: 6,
      widthScreens: 1,
      heightScreens: 1,
    },
    {
      roomId: 37886,
      roomIdHex: "0x93FE",
      handle: "westOcean",
      name: "West Ocean",
      area: 0,
      areaName: "Crateria",
      mapX: 38,
      mapY: 0,
      widthScreens: 8,
      heightScreens: 6,
    },
    {
      roomId: 37985,
      roomIdHex: "0x9461",
      handle: "bowlingAlleyPath",
      name: "Bowling Alley Path",
      area: 0,
      areaName: "Crateria",
      mapX: 41,
      mapY: 2,
      widthScreens: 2,
      heightScreens: 1,
    },
    {
      roomId: 38028,
      roomIdHex: "0x948C",
      handle: "crateriaKihunterRoom",
      name: "Crateria Kihunter Room",
      area: 0,
      areaName: "Crateria",
      mapX: 33,
      mapY: 4,
      widthScreens: 3,
      heightScreens: 3,
    },
    {
      roomId: 38092,
      roomIdHex: "0x94CC",
      handle: "elevatorToMaridia",
      name: "Elevator To Maridia",
      area: 0,
      areaName: "Crateria",
      mapX: 52,
      mapY: 10,
      widthScreens: 1,
      heightScreens: 1,
    },
    {
      roomId: 38141,
      roomIdHex: "0x94FD",
      handle: "eastOcean",
      name: "East Ocean",
      area: 0,
      areaName: "Crateria",
      mapX: 49,
      mapY: 0,
      widthScreens: 7,
      heightScreens: 6,
    },
    {
      roomId: 38226,
      roomIdHex: "0x9552",
      handle: "forgottenHighwayKagoRoom",
      name: "Forgotten Highway Kago Room",
      area: 0,
      areaName: "Crateria",
      mapX: 56,
      mapY: 4,
      widthScreens: 1,
      heightScreens: 4,
    },
    {
      roomId: 38269,
      roomIdHex: "0x957D",
      handle: "crabMaze",
      name: "Crab Maze",
      area: 0,
      areaName: "Crateria",
      mapX: 53,
      mapY: 8,
      widthScreens: 4,
      heightScreens: 2,
    },
    {
      roomId: 38312,
      roomIdHex: "0x95A8",
      handle: "forgottenHighwayElbow",
      name: "Forgotten Highway Elbow",
      area: 0,
      areaName: "Crateria",
      mapX: 52,
      mapY: 9,
      widthScreens: 1,
      heightScreens: 1,
    },
    {
      roomId: 38356,
      roomIdHex: "0x95D4",
      handle: "crateriaTube",
      name: "Crateria Tube",
      area: 0,
      areaName: "Crateria",
      mapX: 32,
      mapY: 4,
      widthScreens: 1,
      heightScreens: 1,
    },
    {
      roomId: 38399,
      roomIdHex: "0x95FF",
      handle: "crateriaMoat",
      name: "The Moat",
      area: 0,
      areaName: "Crateria",
      mapX: 36,
      mapY: 4,
      widthScreens: 2,
      heightScreens: 2,
    },
    {
      roomId: 38442,
      roomIdHex: "0x962A",
      handle: "elevatorToCaterpillar",
      name: "Elevator To Caterpillar",
      area: 0,
      areaName: "Crateria",
      mapX: 34,
      mapY: 7,
      widthScreens: 1,
      heightScreens: 1,
    },
    {
      roomId: 38491,
      roomIdHex: "0x965B",
      handle: "gauntletETankRoom",
      name: "Gauntlet Energy Tank Room",
      area: 0,
      areaName: "Crateria",
      mapX: 12,
      mapY: 2,
      widthScreens: 6,
      heightScreens: 1,
    },
    {
      roomId: 38543,
      roomIdHex: "0x968F",
      handle: "crateriaPartialRoom",
      name: "Crateria Partial Room",
      area: 0,
      areaName: "Crateria",
      mapX: 43,
      mapY: 2,
      widthScreens: 1,
      heightScreens: 1,
    },
    {
      roomId: 38586,
      roomIdHex: "0x96BA",
      handle: "climb",
      name: "The Climb",
      area: 0,
      areaName: "Crateria",
      mapX: 18,
      mapY: 9,
      widthScreens: 3,
      heightScreens: 9,
    },
    {
      roomId: 38748,
      roomIdHex: "0x975C",
      handle: "pitRoom",
      name: "Pit Room",
      area: 0,
      areaName: "Crateria",
      mapX: 20,
      mapY: 17,
      widthScreens: 3,
      heightScreens: 2,
    },
    {
      roomId: 38837,
      roomIdHex: "0x97B5",
      handle: "elevatorToMorphBall",
      name: "Elevator To Morph Ball",
      area: 0,
      areaName: "Crateria",
      mapX: 23,
      mapY: 17,
      widthScreens: 1,
      heightScreens: 1,
    },
    {
      roomId: 38916,
      roomIdHex: "0x9804",
      handle: "bombTorizo",
      name: "Bomb Torizo Room",
      area: 0,
      areaName: "Crateria",
      mapX: 25,
      mapY: 6,
      widthScreens: 1,
      heightScreens: 1,
    },
    {
      roomId: 39033,
      roomIdHex: "0x9879",
      handle: "flyway",
      name: "Flyway",
      area: 0,
      areaName: "Crateria",
      mapX: 22,
      mapY: 6,
      widthScreens: 3,
      heightScreens: 1,
    },
    {
      roomId: 39138,
      roomIdHex: "0x98E2",
      handle: "preMapFlyway",
      name: "Pre-Map Flyway",
      area: 0,
      areaName: "Crateria",
      mapX: 20,
      mapY: 7,
      widthScreens: 3,
      heightScreens: 1,
    },
    {
      roomId: 39181,
      roomIdHex: "0x990D",
      handle: "terminator",
      name: "Terminator Room",
      area: 0,
      areaName: "Crateria",
      mapX: 12,
      mapY: 4,
      widthScreens: 6,
      heightScreens: 3,
    },
    {
      roomId: 39224,
      roomIdHex: "0x9938",
      handle: "elevatorToGreenBrinstar",
      name: "Elevator To Green Brinstar",
      area: 0,
      areaName: "Crateria",
      mapX: 6,
      mapY: 8,
      widthScreens: 1,
      heightScreens: 1,
    },
    {
      roomId: 39273,
      roomIdHex: "0x9969",
      handle: "lowerMushrooms",
      name: "Lower Mushrooms",
      area: 0,
      areaName: "Crateria",
      mapX: 7,
      mapY: 8,
      widthScreens: 4,
      heightScreens: 1,
    },
    {
      roomId: 39316,
      roomIdHex: "0x9994",
      handle: "crateriaMapRoom",
      name: "Crateria Map Room",
      area: 0,
      areaName: "Crateria",
      mapX: 23,
      mapY: 7,
      widthScreens: 1,
      heightScreens: 1,
    },
    {
      roomId: 39357,
      roomIdHex: "0x99BD",
      handle: "greenPirateShaft",
      name: "Green Pirates Shaft",
      area: 0,
      areaName: "Crateria",
      mapX: 11,
      mapY: 2,
      widthScreens: 1,
      heightScreens: 7,
    },
    {
      roomId: 39417,
      roomIdHex: "0x99F9",
      handle: "crateriaSupersRoom",
      name: "Crateria Super Room",
      area: 0,
      areaName: "Crateria",
      mapX: 21,
      mapY: 9,
      widthScreens: 4,
      heightScreens: 8,
    },
    {
      roomId: 39492,
      roomIdHex: "0x9A44",
      handle: "finalMissileBombway",
      name: "Final Missile Bombway",
      area: 0,
      areaName: "Crateria",
      mapX: 17,
      mapY: 7,
      widthScreens: 2,
      heightScreens: 1,
    },
    {
      roomId: 39568,
      roomIdHex: "0x9A90",
      handle: "theFinalMissile",
      name: "The Final Missile",
      area: 0,
      areaName: "Crateria",
      mapX: 16,
      mapY: 7,
      widthScreens: 1,
      heightScreens: 1,
    },
    {
      roomId: 39641,
      roomIdHex: "0x9AD9",
      handle: "greenBrinstarMainShaft",
      name: "Green Brinstar Main Shaft",
      area: 1,
      areaName: "Brinstar",
      mapX: 9,
      mapY: 0,
      widthScreens: 4,
      heightScreens: 12,
    },
    {
      roomId: 39771,
      roomIdHex: "0x9B5B",
      handle: "sporeSpawnSuper",
      name: "Spore Spawn Super Room",
      area: 1,
      areaName: "Brinstar",
      mapX: 23,
      mapY: 1,
      widthScreens: 2,
      heightScreens: 9,
    },
    {
      roomId: 39837,
      roomIdHex: "0x9B9D",
      handle: "brinstarPreMapRoom",
      name: "Brinstar Pre-Map Room",
      area: 1,
      areaName: "Brinstar",
      mapX: 6,
      mapY: 4,
      widthScreens: 3,
      heightScreens: 1,
    },
    {
      roomId: 39880,
      roomIdHex: "0x9BC8",
      handle: "earlySupers",
      name: "Early Supers Room",
      area: 1,
      areaName: "Brinstar",
      mapX: 10,
      mapY: 3,
      widthScreens: 3,
      heightScreens: 2,
    },
    {
      roomId: 39943,
      roomIdHex: "0x9C07",
      handle: "brinstarReserveRoom",
      name: "Brinstar Reserve Tank Room",
      area: 1,
      areaName: "Brinstar",
      mapX: 13,
      mapY: 4,
      widthScreens: 2,
      heightScreens: 1,
    },
    {
      roomId: 39989,
      roomIdHex: "0x9C35",
      handle: "brinstarMapRoom",
      name: "Brinstar Map Room",
      area: 1,
      areaName: "Brinstar",
      mapX: 5,
      mapY: 4,
      widthScreens: 1,
      heightScreens: 1,
    },
    {
      roomId: 40030,
      roomIdHex: "0x9C5E",
      handle: "greenBrinstarFirefleaRoom",
      name: "Green Brinstar Fireflea Room",
      area: 1,
      areaName: "Brinstar",
      mapX: 6,
      mapY: 6,
      widthScreens: 3,
      heightScreens: 2,
    },
    {
      roomId: 40073,
      roomIdHex: "0x9C89",
      handle: "greenBrinstarMissileStation",
      name: "Green Brinstar Missile Station",
      area: 1,
      areaName: "Brinstar",
      mapX: 5,
      mapY: 7,
      widthScreens: 1,
      heightScreens: 1,
    },
    {
      roomId: 40115,
      roomIdHex: "0x9CB3",
      handle: "dachoraRoom",
      name: "Dachora Room",
      area: 1,
      areaName: "Brinstar",
      mapX: 10,
      mapY: 6,
      widthScreens: 7,
      heightScreens: 7,
    },
    {
      roomId: 40217,
      roomIdHex: "0x9D19",
      handle: "bigPink",
      name: "Big Pink",
      area: 1,
      areaName: "Brinstar",
      mapX: 15,
      mapY: 4,
      widthScreens: 5,
      heightScreens: 10,
    },
    {
      roomId: 40348,
      roomIdHex: "0x9D9C",
      handle: "sporeSpawnKeyhunter",
      name: "Spore Spawn Keyhunter Room",
      area: 1,
      areaName: "Brinstar",
      mapX: 19,
      mapY: 4,
      widthScreens: 4,
      heightScreens: 1,
    },
    {
      roomId: 40391,
      roomIdHex: "0x9DC7",
      handle: "sporeSpawn",
      name: "Spore Spawn Room",
      area: 1,
      areaName: "Brinstar",
      mapX: 22,
      mapY: 1,
      widthScreens: 1,
      heightScreens: 3,
    },
    {
      roomId: 40465,
      roomIdHex: "0x9E11",
      handle: "pinkBrinstarPowerBombRoom",
      name: "Pink Brinstar Power Bomb Room",
      area: 1,
      areaName: "Brinstar",
      mapX: 15,
      mapY: 7,
      widthScreens: 2,
      heightScreens: 2,
    },
    {
      roomId: 40530,
      roomIdHex: "0x9E52",
      handle: "greenHills",
      name: "Green Hill Zone",
      area: 1,
      areaName: "Brinstar",
      mapX: 19,
      mapY: 10,
      widthScreens: 8,
      heightScreens: 4,
    },
    {
      roomId: 40607,
      roomIdHex: "0x9E9F",
      handle: "morphBall",
      name: "Morph Ball Room",
      area: 1,
      areaName: "Brinstar",
      mapX: 21,
      mapY: 8,
      widthScreens: 8,
      heightScreens: 3,
    },
    {
      roomId: 40721,
      roomIdHex: "0x9F11",
      handle: "constructionZone",
      name: "Construction Zone",
      area: 1,
      areaName: "Brinstar",
      mapX: 29,
      mapY: 10,
      widthScreens: 1,
      heightScreens: 2,
    },
    {
      roomId: 40804,
      roomIdHex: "0x9F64",
      handle: "blueBrinstarETankRoom",
      name: "Blue Brinstar Energy Tank Room",
      area: 1,
      areaName: "Brinstar",
      mapX: 30,
      mapY: 8,
      widthScreens: 3,
      heightScreens: 3,
    },
    {
      roomId: 40890,
      roomIdHex: "0x9FBA",
      handle: "noobBridge",
      name: "Noob Bridge",
      area: 1,
      areaName: "Brinstar",
      mapX: 27,
      mapY: 13,
      widthScreens: 6,
      heightScreens: 1,
    },
    {
      roomId: 40933,
      roomIdHex: "0x9FE5",
      handle: "greenBrinstarBeetomRoom",
      name: "Green Brinstar Beetom Room",
      area: 1,
      areaName: "Brinstar",
      mapX: 8,
      mapY: 10,
      widthScreens: 1,
      heightScreens: 1,
    },
    {
      roomId: 40977,
      roomIdHex: "0xA011",
      handle: "etacoonETankRoom",
      name: "Etacoon Energy Tank Room",
      area: 1,
      areaName: "Brinstar",
      mapX: 6,
      mapY: 10,
      widthScreens: 5,
      heightScreens: 2,
    },
    {
      roomId: 41041,
      roomIdHex: "0xA051",
      handle: "etacoonSuperRoom",
      name: "Etacoon Super Room",
      area: 1,
      areaName: "Brinstar",
      mapX: 5,
      mapY: 10,
      widthScreens: 1,
      heightScreens: 1,
    },
    {
      roomId: 41083,
      roomIdHex: "0xA07B",
      handle: "dachoraEnergyChargeStation",
      name: "Dachora Energy Charge Station",
      area: 1,
      areaName: "Brinstar",
      mapX: 9,
      mapY: 12,
      widthScreens: 1,
      heightScreens: 1,
    },
    {
      roomId: 41124,
      roomIdHex: "0xA0A4",
      handle: "sporeSpawnFarmingRoom",
      name: "Spore Spawn Farming Room",
      area: 1,
      areaName: "Brinstar",
      mapX: 20,
      mapY: 9,
      widthScreens: 3,
      heightScreens: 1,
    },
    {
      roomId: 41170,
      roomIdHex: "0xA0D2",
      handle: "waterway",
      name: "Waterway",
      area: 1,
      areaName: "Brinstar",
      mapX: 8,
      mapY: 13,
      widthScreens: 7,
      heightScreens: 1,
    },
    {
      roomId: 41223,
      roomIdHex: "0xA107",
      handle: "alphaMissileRoom",
      name: "First Missile Room",
      area: 1,
      areaName: "Brinstar",
      mapX: 28,
      mapY: 11,
      widthScreens: 1,
      heightScreens: 1,
    },
    {
      roomId: 41264,
      roomIdHex: "0xA130",
      handle: "pinkBrinstarHopperRoom",
      name: "Pink Brinstar Hopper Room",
      area: 1,
      areaName: "Brinstar",
      mapX: 19,
      mapY: 7,
      widthScreens: 2,
      heightScreens: 2,
    },
    {
      roomId: 41307,
      roomIdHex: "0xA15B",
      handle: "hopperETankRoom",
      name: "Hopper Energy Tank Room",
      area: 1,
      areaName: "Brinstar",
      mapX: 21,
      mapY: 8,
      widthScreens: 1,
      heightScreens: 1,
    },
    {
      roomId: 41348,
      roomIdHex: "0xA184",
      handle: "bigPinkSaveRoom",
      name: "Big Pink Save Room",
      area: 1,
      areaName: "Brinstar",
      mapX: 15,
      mapY: 4,
      widthScreens: 1,
      heightScreens: 1,
    },
    {
      roomId: 41389,
      roomIdHex: "0xA1AD",
      handle: "blueBrinstarBoulderRoom",
      name: "Blue Brinstar Boulder Room",
      area: 1,
      areaName: "Brinstar",
      mapX: 30,
      mapY: 8,
      widthScreens: 2,
      heightScreens: 1,
    },
    {
      roomId: 41432,
      roomIdHex: "0xA1D8",
      handle: "billyMays",
      name: "Billy Mays' Room",
      area: 1,
      areaName: "Brinstar",
      mapX: 29,
      mapY: 8,
      widthScreens: 1,
      heightScreens: 1,
    },
    {
      roomId: 41473,
      roomIdHex: "0xA201",
      handle: "etecoonSaveRoom",
      name: "Etecoon Save Room",
      area: 1,
      areaName: "Brinstar",
      mapX: 8,
      mapY: 5,
      widthScreens: 1,
      heightScreens: 1,
    },
    {
      roomId: 41514,
      roomIdHex: "0xA22A",
      handle: "etecoonSaveRoom2",
      name: "Etecoon Save Room 2",
      area: 1,
      areaName: "Brinstar",
      mapX: 5,
      mapY: 11,
      widthScreens: 1,
      heightScreens: 1,
    },
    {
      roomId: 41555,
      roomIdHex: "0xA253",
      handle: "redTower",
      name: "Red Tower",
      area: 1,
      areaName: "Brinstar",
      mapX: 33,
      mapY: 9,
      widthScreens: 1,
      heightScreens: 10,
    },
    {
      roomId: 41619,
      roomIdHex: "0xA293",
      handle: "redBrinstarFirefleaRoom",
      name: "Red Brinstar Fireflea Room",
      area: 1,
      areaName: "Brinstar",
      mapX: 25,
      mapY: 15,
      widthScreens: 8,
      heightScreens: 2,
    },
    {
      roomId: 41678,
      roomIdHex: "0xA2CE",
      handle: "xRay",
      name: "X-Ray Room",
      area: 1,
      areaName: "Brinstar",
      mapX: 23,
      mapY: 15,
      widthScreens: 2,
      heightScreens: 1,
    },
    {
      roomId: 41719,
      roomIdHex: "0xA2F7",
      handle: "hellway",
      name: "Hellway",
      area: 1,
      areaName: "Brinstar",
      mapX: 34,
      mapY: 9,
      widthScreens: 3,
      heightScreens: 1,
    },
    {
      roomId: 41762,
      roomIdHex: "0xA322",
      handle: "caterpillar",
      name: "Caterpillar Room",
      area: 1,
      areaName: "Brinstar",
      mapX: 37,
      mapY: 4,
      widthScreens: 3,
      heightScreens: 8,
    },
    {
      roomId: 41852,
      roomIdHex: "0xA37C",
      handle: "betaPowerBombRoom",
      name: "Beta Power Bomb Room",
      area: 1,
      areaName: "Brinstar",
      mapX: 35,
      mapY: 7,
      widthScreens: 2,
      heightScreens: 2,
    },
    {
      roomId: 41902,
      roomIdHex: "0xA3AE",
      handle: "alphaPowerBombsRoom",
      name: "Alpha Power Bomb Room",
      area: 1,
      areaName: "Brinstar",
      mapX: 34,
      mapY: 11,
      widthScreens: 3,
      heightScreens: 1,
    },
    {
      roomId: 41949,
      roomIdHex: "0xA3DD",
      handle: "bat",
      name: "Bat Room",
      area: 1,
      areaName: "Brinstar",
      mapX: 34,
      mapY: 18,
      widthScreens: 2,
      heightScreens: 1,
    },
    {
      roomId: 41992,
      roomIdHex: "0xA408",
      handle: "belowSpazer",
      name: "Below Spazer",
      area: 1,
      areaName: "Brinstar",
      mapX: 36,
      mapY: 17,
      widthScreens: 2,
      heightScreens: 2,
    },
    {
      roomId: 42055,
      roomIdHex: "0xA447",
      handle: "spazer",
      name: "Spazer Room",
      area: 1,
      areaName: "Brinstar",
      mapX: 38,
      mapY: 17,
      widthScreens: 1,
      heightScreens: 1,
    },
    {
      roomId: 42097,
      roomIdHex: "0xA471",
      handle: "warehouseZeela",
      name: "Warehouse Zeela Room",
      area: 1,
      areaName: "Brinstar",
      mapX: 44,
      mapY: 18,
      widthScreens: 2,
      heightScreens: 2,
    },
    {
      roomId: 42161,
      roomIdHex: "0xA4B1",
      handle: "warehouseETankRoom",
      name: "Warehouse Energy Tank Room",
      area: 1,
      areaName: "Brinstar",
      mapX: 43,
      mapY: 19,
      widthScreens: 1,
      heightScreens: 1,
    },
    {
      roomId: 42202,
      roomIdHex: "0xA4DA",
      handle: "warehouseKiHunters",
      name: "Warehouse Kihunter Room",
      area: 1,
      areaName: "Brinstar",
      mapX: 45,
      mapY: 18,
      widthScreens: 4,
      heightScreens: 2,
    },
    {
      roomId: 42273,
      roomIdHex: "0xA521",
      handle: "babyKraidRoom",
      name: "Baby Kraid Room",
      area: 1,
      areaName: "Brinstar",
      mapX: 47,
      mapY: 19,
      widthScreens: 6,
      heightScreens: 1,
    },
    {
      roomId: 42347,
      roomIdHex: "0xA56B",
      handle: "kraidEyeDoor",
      name: "Kraid's Eye Door",
      area: 1,
      areaName: "Brinstar",
      mapX: 53,
      mapY: 18,
      widthScreens: 2,
      heightScreens: 2,
    },
    {
      roomId: 42399,
      roomIdHex: "0xA59F",
      handle: "kraid",
      name: "Kraid's Room",
      area: 1,
      areaName: "Brinstar",
      mapX: 55,
      mapY: 18,
      widthScreens: 2,
      heightScreens: 2,
    },
    {
      roomId: 42477,
      roomIdHex: "0xA5ED",
      handle: "statuesHallway",
      name: "Statues Hallway",
      area: 0,
      areaName: "Crateria",
      mapX: 12,
      mapY: 8,
      widthScreens: 5,
      heightScreens: 1,
    },
    {
      roomId: 42520,
      roomIdHex: "0xA618",
      handle: "sloatersRefill",
      name: "Sloaters Refill",
      area: 1,
      areaName: "Brinstar",
      mapX: 32,
      mapY: 18,
      widthScreens: 1,
      heightScreens: 1,
    },
    {
      roomId: 42561,
      roomIdHex: "0xA641",
      handle: "kraidRechargeStations",
      name: "Kraid Recharge Stations",
      area: 1,
      areaName: "Brinstar",
      mapX: 54,
      mapY: 18,
      widthScreens: 1,
      heightScreens: 1,
    },
    {
      roomId: 42602,
      roomIdHex: "0xA66A",
      handle: "statues",
      name: "Statues Room",
      area: 0,
      areaName: "Crateria",
      mapX: 17,
      mapY: 8,
      widthScreens: 1,
      heightScreens: 2,
    },
    {
      roomId: 42657,
      roomIdHex: "0xA6A1",
      handle: "warehouseEntrance",
      name: "Warehouse Entrance",
      area: 1,
      areaName: "Brinstar",
      mapX: 41,
      mapY: 18,
      widthScreens: 3,
      heightScreens: 2,
    },
    {
      roomId: 42722,
      roomIdHex: "0xA6E2",
      handle: "varia",
      name: "Varia Suit Room",
      area: 1,
      areaName: "Brinstar",
      mapX: 57,
      mapY: 19,
      widthScreens: 1,
      heightScreens: 1,
    },
    {
      roomId: 42763,
      roomIdHex: "0xA70B",
      handle: "warehouseSaveRoom",
      name: "Warehouse Save Room",
      area: 1,
      areaName: "Brinstar",
      mapX: 49,
      mapY: 18,
      widthScreens: 1,
      heightScreens: 1,
    },
    {
      roomId: 42804,
      roomIdHex: "0xA734",
      handle: "redBrinstarSaveRoom",
      name: "Red Brinstar Save Room",
      area: 1,
      areaName: "Brinstar",
      mapX: 38,
      mapY: 8,
      widthScreens: 1,
      heightScreens: 1,
    },
    {
      roomId: 42845,
      roomIdHex: "0xA75D",
      handle: "iceBeamAcidRoom",
      name: "Ice Beam Acid Room",
      area: 2,
      areaName: "Norfair",
      mapX: 4,
      mapY: 3,
      widthScreens: 2,
      heightScreens: 1,
    },
    {
      roomId: 42888,
      roomIdHex: "0xA788",
      handle: "cathedral",
      name: "Cathedral",
      area: 2,
      areaName: "Norfair",
      mapX: 14,
      mapY: 3,
      widthScreens: 3,
      heightScreens: 2,
    },
    {
      roomId: 42931,
      roomIdHex: "0xA7B3",
      handle: "cathedralEntrance",
      name: "Cathedral Entrance",
      area: 2,
      areaName: "Norfair",
      mapX: 11,
      mapY: 3,
      widthScreens: 3,
      heightScreens: 2,
    },
    {
      roomId: 42974,
      roomIdHex: "0xA7DE",
      handle: "businessCenter",
      name: "Business Center",
      area: 2,
      areaName: "Norfair",
      mapX: 10,
      mapY: 0,
      widthScreens: 1,
      heightScreens: 7,
    },
    {
      roomId: 43029,
      roomIdHex: "0xA815",
      handle: "iceBeamGateRoom",
      name: "Ice Beam Gate Room",
      area: 2,
      areaName: "Norfair",
      mapX: 3,
      mapY: 1,
      widthScreens: 7,
      heightScreens: 4,
    },
    {
      roomId: 43109,
      roomIdHex: "0xA865",
      handle: "iceBeamTutorialRoom",
      name: "Ice Beam Tutorial Room",
      area: 2,
      areaName: "Norfair",
      mapX: 4,
      mapY: 1,
      widthScreens: 2,
      heightScreens: 1,
    },
    {
      roomId: 43152,
      roomIdHex: "0xA890",
      handle: "iceBeam",
      name: "Ice Beam Room",
      area: 2,
      areaName: "Norfair",
      mapX: 5,
      mapY: 2,
      widthScreens: 1,
      heightScreens: 1,
    },
    {
      roomId: 43193,
      roomIdHex: "0xA8B9",
      handle: "iceBeamSnakeRoom",
      name: "Ice Beam Snake Room",
      area: 2,
      areaName: "Norfair",
      mapX: 3,
      mapY: 1,
      widthScreens: 2,
      heightScreens: 3,
    },
    {
      roomId: 43256,
      roomIdHex: "0xA8F8",
      handle: "crumbleShaft",
      name: "Crumble Shaft",
      area: 2,
      areaName: "Norfair",
      mapX: 2,
      mapY: 4,
      widthScreens: 1,
      heightScreens: 4,
    },
    {
      roomId: 43299,
      roomIdHex: "0xA923",
      handle: "crocomireSpeedway",
      name: "Crocomire Speedway",
      area: 2,
      areaName: "Norfair",
      mapX: 3,
      mapY: 7,
      widthScreens: 13,
      heightScreens: 3,
    },
    {
      roomId: 43405,
      roomIdHex: "0xA98D",
      handle: "crocomire",
      name: "Crocomire's Room",
      area: 2,
      areaName: "Norfair",
      mapX: 12,
      mapY: 10,
      widthScreens: 8,
      heightScreens: 1,
    },
    {
      roomId: 43493,
      roomIdHex: "0xA9E5",
      handle: "hiJump",
      name: "Hi-Jump Room",
      area: 2,
      areaName: "Norfair",
      mapX: 7,
      mapY: 6,
      widthScreens: 1,
      heightScreens: 1,
    },
    {
      roomId: 43534,
      roomIdHex: "0xAA0E",
      handle: "crocomireEscape",
      name: "Crocomire Escape",
      area: 2,
      areaName: "Norfair",
      mapX: 11,
      mapY: 6,
      widthScreens: 4,
      heightScreens: 2,
    },
    {
      roomId: 43585,
      roomIdHex: "0xAA41",
      handle: "hiJumpShaft",
      name: "Hi-Jump Shaft",
      area: 2,
      areaName: "Norfair",
      mapX: 8,
      mapY: 5,
      widthScreens: 2,
      heightScreens: 2,
    },
    {
      roomId: 43650,
      roomIdHex: "0xAA82",
      handle: "postCrocomireFarmingRoom",
      name: "Post Crocomire Farming Room",
      area: 2,
      areaName: "Norfair",
      mapX: 10,
      mapY: 10,
      widthScreens: 2,
      heightScreens: 2,
    },
    {
      roomId: 43701,
      roomIdHex: "0xAAB5",
      handle: "postCrocomireSaveRoom",
      name: "Post Crocomire Save Room",
      area: 2,
      areaName: "Norfair",
      mapX: 12,
      mapY: 11,
      widthScreens: 1,
      heightScreens: 1,
    },
    {
      roomId: 43742,
      roomIdHex: "0xAADE",
      handle: "postCrocomirePowerBombRoom",
      name: "Post Crocomire Power Bomb Room",
      area: 2,
      areaName: "Norfair",
      mapX: 9,
      mapY: 10,
      widthScreens: 1,
      heightScreens: 1,
    },
    {
      roomId: 43783,
      roomIdHex: "0xAB07",
      handle: "postCrocomireShaft",
      name: "Post Crocomire Shaft",
      area: 2,
      areaName: "Norfair",
      mapX: 10,
      mapY: 12,
      widthScreens: 1,
      heightScreens: 5,
    },
    {
      roomId: 43835,
      roomIdHex: "0xAB3B",
      handle: "cosineRoom",
      name: "Cosine Room",
      area: 2,
      areaName: "Norfair",
      mapX: 11,
      mapY: 15,
      widthScreens: 4,
      heightScreens: 1,
    },
    {
      roomId: 43876,
      roomIdHex: "0xAB64",
      handle: "grappleTutorialRoom3",
      name: "Grapple Tutorial Room 3",
      area: 2,
      areaName: "Norfair",
      mapX: 7,
      mapY: 12,
      widthScreens: 3,
      heightScreens: 2,
    },
    {
      roomId: 43919,
      roomIdHex: "0xAB8F",
      handle: "preGrapple",
      name: "Post Crocomire Jump Room",
      area: 2,
      areaName: "Norfair",
      mapX: 4,
      mapY: 15,
      widthScreens: 8,
      heightScreens: 3,
    },
    {
      roomId: 43986,
      roomIdHex: "0xABD2",
      handle: "grappleTutorialRoom2",
      name: "Grapple Tutorial Room 2",
      area: 2,
      areaName: "Norfair",
      mapX: 6,
      mapY: 12,
      widthScreens: 1,
      heightScreens: 3,
    },
    {
      roomId: 44032,
      roomIdHex: "0xAC00",
      handle: "grappleTutorialRoom1",
      name: "Grapple Tutorial Room 1",
      area: 2,
      areaName: "Norfair",
      mapX: 4,
      mapY: 14,
      widthScreens: 2,
      heightScreens: 1,
    },
    {
      roomId: 44075,
      roomIdHex: "0xAC2B",
      handle: "grapple",
      name: "Grapple Beam Room",
      area: 2,
      areaName: "Norfair",
      mapX: 3,
      mapY: 14,
      widthScreens: 1,
      heightScreens: 4,
    },
    {
      roomId: 44122,
      roomIdHex: "0xAC5A",
      handle: "norfairReserveRoom",
      name: "Norfair Reserve Tank Room",
      area: 2,
      areaName: "Norfair",
      mapX: 18,
      mapY: 2,
      widthScreens: 2,
      heightScreens: 1,
    },
    {
      roomId: 44163,
      roomIdHex: "0xAC83",
      handle: "greenBubblesRoom",
      name: "Green Bubbles Missile Room",
      area: 2,
      areaName: "Norfair",
      mapX: 20,
      mapY: 2,
      widthScreens: 2,
      heightScreens: 1,
    },
    {
      roomId: 44211,
      roomIdHex: "0xACB3",
      handle: "bubbleMountain",
      name: "Bubble Mountain",
      area: 2,
      areaName: "Norfair",
      mapX: 22,
      mapY: 2,
      widthScreens: 2,
      heightScreens: 4,
    },
    {
      roomId: 44272,
      roomIdHex: "0xACF0",
      handle: "speedBoostHall",
      name: "Speed Booster Hall",
      area: 2,
      areaName: "Norfair",
      mapX: 25,
      mapY: 1,
      widthScreens: 12,
      heightScreens: 2,
    },
    {
      roomId: 44315,
      roomIdHex: "0xAD1B",
      handle: "speedBooster",
      name: "Speed Booster Room",
      area: 2,
      areaName: "Norfair",
      mapX: 37,
      mapY: 2,
      widthScreens: 1,
      heightScreens: 1,
    },
    {
      roomId: 44382,
      roomIdHex: "0xAD5E",
      handle: "singleChamber",
      name: "Single Chamber",
      area: 2,
      areaName: "Norfair",
      mapX: 24,
      mapY: 3,
      widthScreens: 6,
      heightScreens: 4,
    },
    {
      roomId: 44461,
      roomIdHex: "0xADAD",
      handle: "doubleChamber",
      name: "Double Chamber",
      area: 2,
      areaName: "Norfair",
      mapX: 25,
      mapY: 4,
      widthScreens: 4,
      heightScreens: 2,
    },
    {
      roomId: 44510,
      roomIdHex: "0xADDE",
      handle: "waveBeam",
      name: "Wave Beam Room",
      area: 2,
      areaName: "Norfair",
      mapX: 29,
      mapY: 4,
      widthScreens: 1,
      heightScreens: 1,
    },
    {
      roomId: 44551,
      roomIdHex: "0xAE07",
      handle: "spikyPlatformsTunnel",
      name: "Spiky Platforms Tunnel",
      area: 2,
      areaName: "Norfair",
      mapX: 25,
      mapY: 6,
      widthScreens: 4,
      heightScreens: 1,
    },
    {
      roomId: 44594,
      roomIdHex: "0xAE32",
      handle: "volcano",
      name: "Volcano Room",
      area: 2,
      areaName: "Norfair",
      mapX: 27,
      mapY: 6,
      widthScreens: 3,
      heightScreens: 3,
    },
    {
      roomId: 44660,
      roomIdHex: "0xAE74",
      handle: "kronicBoost",
      name: "Kronic Boost Room",
      area: 2,
      areaName: "Norfair",
      mapX: 25,
      mapY: 8,
      widthScreens: 2,
      heightScreens: 3,
    },
    {
      roomId: 44724,
      roomIdHex: "0xAEB4",
      handle: "magdolliteTunnel",
      name: "Magdollite Tunnel",
      area: 2,
      areaName: "Norfair",
      mapX: 23,
      mapY: 8,
      widthScreens: 3,
      heightScreens: 1,
    },
    {
      roomId: 44767,
      roomIdHex: "0xAEDF",
      handle: "purpleShaft",
      name: "Purple Shaft",
      area: 2,
      areaName: "Norfair",
      mapX: 22,
      mapY: 6,
      widthScreens: 1,
      heightScreens: 3,
    },
    {
      roomId: 44820,
      roomIdHex: "0xAF14",
      handle: "lavaDiveRoom",
      name: "Lava Dive Room",
      area: 2,
      areaName: "Norfair",
      mapX: 22,
      mapY: 10,
      widthScreens: 4,
      heightScreens: 3,
    },
    {
      roomId: 44863,
      roomIdHex: "0xAF3F",
      handle: "lowerNorfairElevator",
      name: "Lower Norfair Elevator",
      area: 2,
      areaName: "Norfair",
      mapX: 21,
      mapY: 10,
      widthScreens: 1,
      heightScreens: 1,
    },
    {
      roomId: 44914,
      roomIdHex: "0xAF72",
      handle: "upperNorfairFarmingRoom",
      name: "Upper Norfair Farming Room",
      area: 2,
      areaName: "Norfair",
      mapX: 20,
      mapY: 5,
      widthScreens: 2,
      heightScreens: 2,
    },
    {
      roomId: 44963,
      roomIdHex: "0xAFA3",
      handle: "risingTide",
      name: "Rising Tide",
      area: 2,
      areaName: "Norfair",
      mapX: 17,
      mapY: 4,
      widthScreens: 5,
      heightScreens: 1,
    },
    {
      roomId: 45006,
      roomIdHex: "0xAFCE",
      handle: "acidSnakesTunnel",
      name: "Acid Snakes Tunnel",
      area: 2,
      areaName: "Norfair",
      mapX: 16,
      mapY: 9,
      widthScreens: 4,
      heightScreens: 1,
    },
    {
      roomId: 45051,
      roomIdHex: "0xAFFB",
      handle: "spikyAcidSnakes",
      name: "Spiky Acid Snakes Room",
      area: 2,
      areaName: "Norfair",
      mapX: 21,
      mapY: 9,
      widthScreens: 4,
      heightScreens: 1,
    },
    {
      roomId: 45094,
      roomIdHex: "0xB026",
      handle: "nutellaRefill",
      name: "Nutella Refill",
      area: 2,
      areaName: "Norfair",
      mapX: 20,
      mapY: 9,
      widthScreens: 1,
      heightScreens: 1,
    },
    {
      roomId: 45137,
      roomIdHex: "0xB051",
      handle: "purpleFarmingRoom",
      name: "Purple Farming Room",
      area: 2,
      areaName: "Norfair",
      mapX: 23,
      mapY: 7,
      widthScreens: 1,
      heightScreens: 1,
    },
    {
      roomId: 45178,
      roomIdHex: "0xB07A",
      handle: "batCave",
      name: "Bat Cave",
      area: 2,
      areaName: "Norfair",
      mapX: 24,
      mapY: 1,
      widthScreens: 1,
      heightScreens: 2,
    },
    {
      roomId: 45236,
      roomIdHex: "0xB0B4",
      handle: "norfairMapRoom",
      name: "Norfair Map Room",
      area: 2,
      areaName: "Norfair",
      mapX: 9,
      mapY: 4,
      widthScreens: 1,
      heightScreens: 1,
    },
    {
      roomId: 45277,
      roomIdHex: "0xB0DD",
      handle: "bubbleMountainSaveRoom",
      name: "Bubble Mountain Save Room",
      area: 2,
      areaName: "Norfair",
      mapX: 21,
      mapY: 3,
      widthScreens: 1,
      heightScreens: 1,
    },
    {
      roomId: 45318,
      roomIdHex: "0xB106",
      handle: "frogSpeedway",
      name: "Frog Speedway",
      area: 2,
      areaName: "Norfair",
      mapX: 12,
      mapY: 5,
      widthScreens: 8,
      heightScreens: 1,
    },
    {
      roomId: 45369,
      roomIdHex: "0xB139",
      handle: "redPirateShaft",
      name: "Red Pirate Shaft",
      area: 2,
      areaName: "Norfair",
      mapX: 19,
      mapY: 6,
      widthScreens: 1,
      heightScreens: 3,
    },
    {
      roomId: 45415,
      roomIdHex: "0xB167",
      handle: "frogSavestation",
      name: "Frog Savestation",
      area: 2,
      areaName: "Norfair",
      mapX: 11,
      mapY: 5,
      widthScreens: 1,
      heightScreens: 1,
    },
    {
      roomId: 45458,
      roomIdHex: "0xB192",
      handle: "crocomireSaveRoom",
      name: "Crocomire Save Room",
      area: 2,
      areaName: "Norfair",
      mapX: 16,
      mapY: 8,
      widthScreens: 1,
      heightScreens: 1,
    },
    {
      roomId: 45499,
      roomIdHex: "0xB1BB",
      handle: "lowerNorfairElevatorSaveRoom",
      name: "Lower Norfair Elevator Save Room",
      area: 2,
      areaName: "Norfair",
      mapX: 20,
      mapY: 10,
      widthScreens: 1,
      heightScreens: 1,
    },
    {
      roomId: 45541,
      roomIdHex: "0xB1E5",
      handle: "acidStatue",
      name: "Acid Statue Room",
      area: 2,
      areaName: "Norfair",
      mapX: 15,
      mapY: 13,
      widthScreens: 3,
      heightScreens: 3,
    },
    {
      roomId: 45622,
      roomIdHex: "0xB236",
      handle: "mainHall",
      name: "Main Hall",
      area: 2,
      areaName: "Norfair",
      mapX: 17,
      mapY: 11,
      widthScreens: 8,
      heightScreens: 3,
    },
    {
      roomId: 45699,
      roomIdHex: "0xB283",
      handle: "goldenTorizo",
      name: "Golden Torizo's Room",
      area: 2,
      areaName: "Norfair",
      mapX: 18,
      mapY: 15,
      widthScreens: 2,
      heightScreens: 2,
    },
    {
      roomId: 45786,
      roomIdHex: "0xB2DA",
      handle: "fastRipperRoom",
      name: "Fast Ripper Room",
      area: 2,
      areaName: "Norfair",
      mapX: 21,
      mapY: 14,
      widthScreens: 4,
      heightScreens: 1,
    },
    {
      roomId: 45829,
      roomIdHex: "0xB305",
      handle: "goldenTorizoEnergyRecharge",
      name: "Golden Torizo Energy Recharge",
      area: 2,
      areaName: "Norfair",
      mapX: 21,
      mapY: 15,
      widthScreens: 1,
      heightScreens: 1,
    },
    {
      roomId: 45870,
      roomIdHex: "0xB32E",
      handle: "ridley",
      name: "Ridley's Room",
      area: 2,
      areaName: "Norfair",
      mapX: 23,
      mapY: 16,
      widthScreens: 1,
      heightScreens: 2,
    },
    {
      roomId: 45946,
      roomIdHex: "0xB37A",
      handle: "lowerNorfairFarming",
      name: "Lower Norfair Farming Room",
      area: 2,
      areaName: "Norfair",
      mapX: 24,
      mapY: 16,
      widthScreens: 3,
      heightScreens: 1,
    },
    {
      roomId: 45989,
      roomIdHex: "0xB3A5",
      handle: "fastPillarsSetupRoom",
      name: "Fast Pillars Setup Room",
      area: 2,
      areaName: "Norfair",
      mapX: 25,
      mapY: 12,
      widthScreens: 1,
      heightScreens: 3,
    },
    // {
    //   roomId: 46049,
    //   roomIdHex: "0xB3E1",
    //   handle: "unusedLowerNorfairRoom",
    //   name: "Unused Lower Norfair Room",
    //   area: 2,
    //   areaName: "Norfair",
    //   mapX: 26,
    //   mapY: 11,
    //   widthScreens: 1,
    //   heightScreens: 1,
    // },
    {
      roomId: 46090,
      roomIdHex: "0xB40A",
      handle: "mickeyMouse",
      name: "Mickey Mouse Room",
      area: 2,
      areaName: "Norfair",
      mapX: 26,
      mapY: 9,
      widthScreens: 4,
      heightScreens: 4,
    },
    {
      roomId: 46167,
      roomIdHex: "0xB457",
      handle: "pillars",
      name: "Pillar Room",
      area: 2,
      areaName: "Norfair",
      mapX: 26,
      mapY: 14,
      widthScreens: 4,
      heightScreens: 1,
    },
    {
      roomId: 46210,
      roomIdHex: "0xB482",
      handle: "plowerhouseRoom",
      name: "Plowerhouse Room",
      area: 2,
      areaName: "Norfair",
      mapX: 27,
      mapY: 16,
      widthScreens: 3,
      heightScreens: 1,
    },
    {
      roomId: 46253,
      roomIdHex: "0xB4AD",
      handle: "writg",
      name: "Worst Room in the Game",
      area: 2,
      areaName: "Norfair",
      mapX: 30,
      mapY: 9,
      widthScreens: 1,
      heightScreens: 6,
    },
    {
      roomId: 46309,
      roomIdHex: "0xB4E5",
      handle: "amphitheatre",
      name: "Amphitheatre",
      area: 2,
      areaName: "Norfair",
      mapX: 31,
      mapY: 9,
      widthScreens: 4,
      heightScreens: 5,
    },
    {
      roomId: 46352,
      roomIdHex: "0xB510",
      handle: "lowerNorfairSpringMaze",
      name: "Lower Norfair Springball Maze Room",
      area: 2,
      areaName: "Norfair",
      mapX: 33,
      mapY: 5,
      widthScreens: 5,
      heightScreens: 2,
    },
    {
      roomId: 46426,
      roomIdHex: "0xB55A",
      handle: "lowerNorfairEscapePowerBombRoom",
      name: "Lower Norfair Escape Power Bomb Room",
      area: 2,
      areaName: "Norfair",
      mapX: 37,
      mapY: 6,
      widthScreens: 1,
      heightScreens: 1,
    },
    {
      roomId: 46469,
      roomIdHex: "0xB585",
      handle: "redKiShaft",
      name: "Red Kihunter Shaft",
      area: 2,
      areaName: "Norfair",
      mapX: 35,
      mapY: 9,
      widthScreens: 3,
      heightScreens: 5,
    },
    {
      roomId: 46549,
      roomIdHex: "0xB5D5",
      handle: "wasteland",
      name: "Wasteland",
      area: 2,
      areaName: "Norfair",
      mapX: 32,
      mapY: 14,
      widthScreens: 6,
      heightScreens: 3,
    },
    {
      roomId: 46635,
      roomIdHex: "0xB62B",
      handle: "metalPirates",
      name: "Metal Pirates Room",
      area: 2,
      areaName: "Norfair",
      mapX: 30,
      mapY: 16,
      widthScreens: 3,
      heightScreens: 1,
    },
    {
      roomId: 46678,
      roomIdHex: "0xB656",
      handle: "threeMusketeers",
      name: "The Musketeers' Room",
      area: 2,
      areaName: "Norfair",
      mapX: 29,
      mapY: 3,
      widthScreens: 4,
      heightScreens: 3,
    },
    {
      roomId: 46744,
      roomIdHex: "0xB698",
      handle: "ridleyETankRoom",
      name: "Ridley Tank Room",
      area: 2,
      areaName: "Norfair",
      mapX: 22,
      mapY: 17,
      widthScreens: 1,
      heightScreens: 1,
    },
    {
      roomId: 46785,
      roomIdHex: "0xB6C1",
      handle: "screwAttack",
      name: "Screw Attack Room",
      area: 2,
      areaName: "Norfair",
      mapX: 20,
      mapY: 14,
      widthScreens: 1,
      heightScreens: 3,
    },
    {
      roomId: 46830,
      roomIdHex: "0xB6EE",
      handle: "lowerNorfairFireflea",
      name: "Lower Norfair Fireflea Room",
      area: 2,
      areaName: "Norfair",
      mapX: 35,
      mapY: 6,
      widthScreens: 3,
      heightScreens: 6,
    },
    {
      roomId: 46913,
      roomIdHex: "0xB741",
      handle: "redKihunterShaftSaveRoom",
      name: "Red Kihunter Shaft Save Room",
      area: 2,
      areaName: "Norfair",
      mapX: 36,
      mapY: 12,
      widthScreens: 1,
      heightScreens: 1,
    },
    {
      roomId: 51598,
      roomIdHex: "0xC98E",
      handle: "bowling",
      name: "Bowling Alley",
      area: 3,
      areaName: "Wrecked Ship",
      mapX: 10,
      mapY: 11,
      widthScreens: 6,
      heightScreens: 3,
    },
    {
      roomId: 51720,
      roomIdHex: "0xCA08",
      handle: "wreckedShipEntrance",
      name: "Wrecked Ship Entrance",
      area: 3,
      areaName: "Wrecked Ship",
      mapX: 12,
      mapY: 14,
      widthScreens: 4,
      heightScreens: 1,
    },
    {
      roomId: 51794,
      roomIdHex: "0xCA52",
      handle: "attic",
      name: "Attic",
      area: 3,
      areaName: "Wrecked Ship",
      mapX: 12,
      mapY: 10,
      widthScreens: 7,
      heightScreens: 1,
    },
    {
      roomId: 51886,
      roomIdHex: "0xCAAE",
      handle: "atticWorkerRobotRoom",
      name: "Wrecked Ship East Missile Room",
      area: 3,
      areaName: "Wrecked Ship",
      mapX: 19,
      mapY: 10,
      widthScreens: 3,
      heightScreens: 1,
    },
    {
      roomId: 51958,
      roomIdHex: "0xCAF6",
      handle: "wreckedShipMainShaft",
      name: "Wrecked Ship Main Shaft",
      area: 3,
      areaName: "Wrecked Ship",
      mapX: 12,
      mapY: 11,
      widthScreens: 6,
      heightScreens: 8,
    },
    {
      roomId: 52107,
      roomIdHex: "0xCB8B",
      handle: "spikyDeathRoom",
      name: "Spiky Death Room",
      area: 3,
      areaName: "Wrecked Ship",
      mapX: 19,
      mapY: 15,
      widthScreens: 2,
      heightScreens: 1,
    },
    {
      roomId: 52181,
      roomIdHex: "0xCBD5",
      handle: "electricDeathRoom",
      name: "Electric Death Room",
      area: 3,
      areaName: "Wrecked Ship",
      mapX: 21,
      mapY: 13,
      widthScreens: 1,
      heightScreens: 3,
    },
    {
      roomId: 52263,
      roomIdHex: "0xCC27",
      handle: "wreckedShipETankRoom",
      name: "Wrecked Ship Energy Tank Room",
      area: 3,
      areaName: "Wrecked Ship",
      mapX: 18,
      mapY: 13,
      widthScreens: 3,
      heightScreens: 2,
    },
    {
      roomId: 52335,
      roomIdHex: "0xCC6F",
      handle: "basement",
      name: "Wrecked Ship Basement",
      area: 3,
      areaName: "Wrecked Ship",
      mapX: 14,
      mapY: 19,
      widthScreens: 5,
      heightScreens: 1,
    },
    {
      roomId: 52427,
      roomIdHex: "0xCCCB",
      handle: "wreckedShipMapRoom",
      name: "Wrecked Ship Map Room",
      area: 3,
      areaName: "Wrecked Ship",
      mapX: 13,
      mapY: 19,
      widthScreens: 1,
      heightScreens: 1,
    },
    {
      roomId: 52499,
      roomIdHex: "0xCD13",
      handle: "phantoon",
      name: "Phantoon's Room",
      area: 3,
      areaName: "Wrecked Ship",
      mapX: 19,
      mapY: 19,
      widthScreens: 1,
      heightScreens: 1,
    },
    {
      roomId: 52572,
      roomIdHex: "0xCD5C",
      handle: "spongeBath",
      name: "Sponge Bath",
      area: 3,
      areaName: "Wrecked Ship",
      mapX: 17,
      mapY: 15,
      widthScreens: 2,
      heightScreens: 1,
    },
    {
      roomId: 52648,
      roomIdHex: "0xCDA8",
      handle: "wreckedShipLeftSuperRoom",
      name: "Wrecked Ship West Super Room",
      area: 3,
      areaName: "Wrecked Ship",
      mapX: 15,
      mapY: 17,
      widthScreens: 1,
      heightScreens: 1,
    },
    {
      roomId: 52721,
      roomIdHex: "0xCDF1",
      handle: "wreckedShipRightSuperRoom",
      name: "Wrecked Ship East Super Room",
      area: 3,
      areaName: "Wrecked Ship",
      mapX: 18,
      mapY: 17,
      widthScreens: 4,
      heightScreens: 1,
    },
    {
      roomId: 52800,
      roomIdHex: "0xCE40",
      handle: "gravity",
      name: "Gravity Suit Room",
      area: 3,
      areaName: "Wrecked Ship",
      mapX: 10,
      mapY: 13,
      widthScreens: 1,
      heightScreens: 1,
    },
    {
      roomId: 52874,
      roomIdHex: "0xCE8A",
      handle: "wreckedShipSaveRoom",
      name: "Wrecked Ship Save Room",
      area: 3,
      areaName: "Wrecked Ship",
      mapX: 17,
      mapY: 14,
      widthScreens: 1,
      heightScreens: 1,
    },
    {
      roomId: 52946,
      roomIdHex: "0xCED2",
      handle: "glassTunnelSaveRoom",
      name: "Glass Tunnel Save Room",
      area: 4,
      areaName: "Maridia",
      mapX: 12,
      mapY: 19,
      widthScreens: 1,
      heightScreens: 1,
    },
    {
      roomId: 52987,
      roomIdHex: "0xCEFB",
      handle: "glassTunnel",
      name: "Glass Tunnel",
      area: 4,
      areaName: "Maridia",
      mapX: 11,
      mapY: 17,
      widthScreens: 1,
      heightScreens: 3,
    },
    {
      roomId: 53076,
      roomIdHex: "0xCF54",
      handle: "westTunnel",
      name: "West Tunnel",
      area: 4,
      areaName: "Maridia",
      mapX: 10,
      mapY: 18,
      widthScreens: 1,
      heightScreens: 1,
    },
    {
      roomId: 53120,
      roomIdHex: "0xCF80",
      handle: "eastTunnel",
      name: "East Tunnel",
      area: 4,
      areaName: "Maridia",
      mapX: 12,
      mapY: 17,
      widthScreens: 4,
      heightScreens: 2,
    },
    {
      roomId: 53193,
      roomIdHex: "0xCFC9",
      handle: "mainStreet",
      name: "Main Street",
      area: 4,
      areaName: "Maridia",
      mapX: 10,
      mapY: 9,
      widthScreens: 3,
      heightScreens: 8,
    },
    {
      roomId: 53271,
      roomIdHex: "0xD017",
      handle: "fishTank",
      name: "Fish Tank",
      area: 4,
      areaName: "Maridia",
      mapX: 13,
      mapY: 13,
      widthScreens: 4,
      heightScreens: 3,
    },
    {
      roomId: 53333,
      roomIdHex: "0xD055",
      handle: "mamaTurtle",
      name: "Mama Turtle Room",
      area: 4,
      areaName: "Maridia",
      mapX: 17,
      mapY: 12,
      widthScreens: 3,
      heightScreens: 4,
    },
    {
      roomId: 53386,
      roomIdHex: "0xD08A",
      handle: "crabTunnel",
      name: "Crab Tunnel",
      area: 4,
      areaName: "Maridia",
      mapX: 12,
      mapY: 16,
      widthScreens: 4,
      heightScreens: 1,
    },
    {
      roomId: 53433,
      roomIdHex: "0xD0B9",
      handle: "mtEverest",
      name: "Mt. Everest",
      area: 4,
      areaName: "Maridia",
      mapX: 12,
      mapY: 9,
      widthScreens: 6,
      heightScreens: 4,
    },
    {
      roomId: 53508,
      roomIdHex: "0xD104",
      handle: "redFishRoom",
      name: "Red Fish Room",
      area: 4,
      areaName: "Maridia",
      mapX: 12,
      mapY: 7,
      widthScreens: 3,
      heightScreens: 2,
    },
    {
      roomId: 53563,
      roomIdHex: "0xD13B",
      handle: "wateringHole",
      name: "Watering Hole",
      area: 4,
      areaName: "Maridia",
      mapX: 12,
      mapY: 4,
      widthScreens: 2,
      heightScreens: 3,
    },
    {
      roomId: 53613,
      roomIdHex: "0xD16D",
      handle: "northwestMaridiaBugRoom",
      name: "Northwest Maridia Bug Room",
      area: 4,
      areaName: "Maridia",
      mapX: 14,
      mapY: 4,
      widthScreens: 4,
      heightScreens: 2,
    },
    {
      roomId: 53667,
      roomIdHex: "0xD1A3",
      handle: "crabShaft",
      name: "Crab Shaft",
      area: 4,
      areaName: "Maridia",
      mapX: 18,
      mapY: 7,
      widthScreens: 2,
      heightScreens: 4,
    },
    {
      roomId: 53725,
      roomIdHex: "0xD1DD",
      handle: "beach",
      name: "Pseudo Plasma Spark Room",
      area: 4,
      areaName: "Maridia",
      mapX: 18,
      mapY: 4,
      widthScreens: 4,
      heightScreens: 3,
    },
    {
      roomId: 53788,
      roomIdHex: "0xD21C",
      handle: "crabHole",
      name: "Crab Hole",
      area: 4,
      areaName: "Maridia",
      mapX: 16,
      mapY: 16,
      widthScreens: 1,
      heightScreens: 2,
    },
    {
      roomId: 53842,
      roomIdHex: "0xD252",
      handle: "westSandHallTunnel",
      name: "West Sand Hall Tunnel",
      area: 4,
      areaName: "Maridia",
      mapX: 17,
      mapY: 16,
      widthScreens: 1,
      heightScreens: 1,
    },
    {
      roomId: 53886,
      roomIdHex: "0xD27E",
      handle: "plasmaTutorialRoom",
      name: "Plasma Tutorial Room",
      area: 4,
      areaName: "Maridia",
      mapX: 26,
      mapY: 0,
      widthScreens: 1,
      heightScreens: 1,
    },
    {
      roomId: 53930,
      roomIdHex: "0xD2AA",
      handle: "plasmaBeam",
      name: "Plasma Beam Room",
      area: 4,
      areaName: "Maridia",
      mapX: 27,
      mapY: 0,
      widthScreens: 2,
      heightScreens: 3,
    },
    {
      roomId: 53977,
      roomIdHex: "0xD2D9",
      handle: "threadTheNeedleRoom",
      name: "Thread The Needle Room",
      area: 4,
      areaName: "Maridia",
      mapX: 27,
      mapY: 5,
      widthScreens: 7,
      heightScreens: 1,
    },
    {
      roomId: 54027,
      roomIdHex: "0xD30B",
      handle: "maridiaElevator",
      name: "Maridia Elevator",
      area: 4,
      areaName: "Maridia",
      mapX: 34,
      mapY: 0,
      widthScreens: 1,
      heightScreens: 6,
    },
    {
      roomId: 54080,
      roomIdHex: "0xD340",
      handle: "plasmaSpark",
      name: "Plasma Spark Room",
      area: 4,
      areaName: "Maridia",
      mapX: 22,
      mapY: 2,
      widthScreens: 4,
      heightScreens: 6,
    },
    {
      roomId: 54151,
      roomIdHex: "0xD387",
      handle: "kassiuzRoom",
      name: "Kassiuz Room",
      area: 4,
      areaName: "Maridia",
      mapX: 25,
      mapY: 0,
      widthScreens: 1,
      heightScreens: 4,
    },
    {
      roomId: 54198,
      roomIdHex: "0xD3B6",
      handle: "maridiaMapRoom",
      name: "Maridia Map Room",
      area: 4,
      areaName: "Maridia",
      mapX: 17,
      mapY: 17,
      widthScreens: 1,
      heightScreens: 1,
    },
    {
      roomId: 54239,
      roomIdHex: "0xD3DF",
      handle: "forgottenHighwaySaveRoom",
      name: "Forgotten Highway Save Room",
      area: 4,
      areaName: "Maridia",
      mapX: 35,
      mapY: 4,
      widthScreens: 1,
      heightScreens: 1,
    },
    {
      roomId: 54280,
      roomIdHex: "0xD408",
      handle: "toiletBowl",
      name: "Toilet Bowl",
      area: 4,
      areaName: "Maridia",
      mapX: 22,
      mapY: 5,
      widthScreens: 1,
      heightScreens: 10,
    },
    {
      roomId: 54323,
      roomIdHex: "0xD433",
      handle: "bugSandHole",
      name: "Bug Sand Hole",
      area: 4,
      areaName: "Maridia",
      mapX: 26,
      mapY: 5,
      widthScreens: 1,
      heightScreens: 1,
    },
    {
      roomId: 54369,
      roomIdHex: "0xD461",
      handle: "westSandHall",
      name: "West Sand Hall",
      area: 4,
      areaName: "Maridia",
      mapX: 18,
      mapY: 16,
      widthScreens: 4,
      heightScreens: 1,
    },
    {
      roomId: 54414,
      roomIdHex: "0xD48E",
      handle: "oasis",
      name: "Oasis",
      area: 4,
      areaName: "Maridia",
      mapX: 22,
      mapY: 15,
      widthScreens: 1,
      heightScreens: 2,
    },
    {
      roomId: 54466,
      roomIdHex: "0xD4C2",
      handle: "eastSandHall",
      name: "East Sand Hall",
      area: 4,
      areaName: "Maridia",
      mapX: 23,
      mapY: 16,
      widthScreens: 3,
      heightScreens: 1,
    },
    {
      roomId: 54511,
      roomIdHex: "0xD4EF",
      handle: "leftSandPit",
      name: "West Sand Hole",
      area: 4,
      areaName: "Maridia",
      mapX: 20,
      mapY: 14,
      widthScreens: 2,
      heightScreens: 2,
    },
    {
      roomId: 54558,
      roomIdHex: "0xD51E",
      handle: "rightSandPit",
      name: "East Sand Hole",
      area: 4,
      areaName: "Maridia",
      mapX: 23,
      mapY: 14,
      widthScreens: 2,
      heightScreens: 2,
    },
    {
      roomId: 54605,
      roomIdHex: "0xD54D",
      handle: "westAqueductQuicksandRoom",
      name: "West Aqueduct Quicksand Room",
      area: 4,
      areaName: "Maridia",
      mapX: 21,
      mapY: 12,
      widthScreens: 1,
      heightScreens: 2,
    },
    {
      roomId: 54650,
      roomIdHex: "0xD57A",
      handle: "eastAqueductQuicksandRoom",
      name: "East Aqueduct Quicksand Room",
      area: 4,
      areaName: "Maridia",
      mapX: 23,
      mapY: 12,
      widthScreens: 1,
      heightScreens: 2,
    },
    {
      roomId: 54695,
      roomIdHex: "0xD5A7",
      handle: "aqueduct",
      name: "Aqueduct",
      area: 4,
      areaName: "Maridia",
      mapX: 20,
      mapY: 9,
      widthScreens: 6,
      heightScreens: 3,
    },
    {
      roomId: 54764,
      roomIdHex: "0xD5EC",
      handle: "butterflyRoom",
      name: "Butterfly Room",
      area: 4,
      areaName: "Maridia",
      mapX: 26,
      mapY: 7,
      widthScreens: 1,
      heightScreens: 1,
    },
    {
      roomId: 54807,
      roomIdHex: "0xD617",
      handle: "botwoonHallway",
      name: "Botwoon Hallway",
      area: 4,
      areaName: "Maridia",
      mapX: 20,
      mapY: 8,
      widthScreens: 4,
      heightScreens: 1,
    },
    {
      roomId: 54854,
      roomIdHex: "0xD646",
      handle: "pantsRoom",
      name: "Pants Room",
      area: 4,
      areaName: "Maridia",
      mapX: 26,
      mapY: 13,
      widthScreens: 2,
      heightScreens: 4,
    },
    {
      roomId: 54938,
      roomIdHex: "0xD69A",
      handle: "eastPantsRoom",
      name: "East Pants Room",
      area: 4,
      areaName: "Maridia",
      mapX: 27,
      mapY: 14,
      widthScreens: 1,
      heightScreens: 3,
    },
    {
      roomId: 54992,
      roomIdHex: "0xD6D0",
      handle: "springBall",
      name: "Spring Ball Room",
      area: 4,
      areaName: "Maridia",
      mapX: 32,
      mapY: 15,
      widthScreens: 2,
      heightScreens: 2,
    },
    {
      roomId: 55037,
      roomIdHex: "0xD6FD",
      handle: "belowBotwoonEnergyTank",
      name: "Below Botwoon Energy Tank",
      area: 4,
      areaName: "Maridia",
      mapX: 26,
      mapY: 10,
      widthScreens: 4,
      heightScreens: 1,
    },
    {
      roomId: 55082,
      roomIdHex: "0xD72A",
      handle: "colosseum",
      name: "Colosseum",
      area: 4,
      areaName: "Maridia",
      mapX: 34,
      mapY: 6,
      widthScreens: 7,
      heightScreens: 2,
    },
    {
      roomId: 55141,
      roomIdHex: "0xD765",
      handle: "aqueductSaveRoom",
      name: "Aqueduct Save Room",
      area: 4,
      areaName: "Maridia",
      mapX: 19,
      mapY: 11,
      widthScreens: 1,
      heightScreens: 1,
    },
    {
      roomId: 55183,
      roomIdHex: "0xD78F",
      handle: "precious",
      name: "The Precious Room",
      area: 4,
      areaName: "Maridia",
      mapX: 41,
      mapY: 7,
      widthScreens: 2,
      heightScreens: 3,
    },
    {
      roomId: 55268,
      roomIdHex: "0xD7E4",
      handle: "botwoonETankRoom",
      name: "Botwoon Energy Tank Room",
      area: 4,
      areaName: "Maridia",
      mapX: 26,
      mapY: 8,
      widthScreens: 7,
      heightScreens: 1,
    },
    {
      roomId: 55322,
      roomIdHex: "0xD81A",
      handle: "draygonSaveRoom",
      name: "Draygon Save Room",
      area: 4,
      areaName: "Maridia",
      mapX: 41,
      mapY: 6,
      widthScreens: 1,
      heightScreens: 1,
    },
    {
      roomId: 55365,
      roomIdHex: "0xD845",
      handle: "maridiaMissileRefillRoom",
      name: "Maridia Missile Refill Room",
      area: 4,
      areaName: "Maridia",
      mapX: 38,
      mapY: 8,
      widthScreens: 1,
      heightScreens: 1,
    },
    {
      roomId: 55406,
      roomIdHex: "0xD86E",
      handle: "plasmaBeachQuicksandRoom",
      name: "Plasma Beach Quicksand Room",
      area: 4,
      areaName: "Maridia",
      mapX: 26,
      mapY: 6,
      widthScreens: 1,
      heightScreens: 1,
    },
    {
      roomId: 55448,
      roomIdHex: "0xD898",
      handle: "botwoonQuicksandRoom",
      name: "Botwoon Quicksand Room",
      area: 4,
      areaName: "Maridia",
      mapX: 28,
      mapY: 9,
      widthScreens: 2,
      heightScreens: 1,
    },
    {
      roomId: 55493,
      roomIdHex: "0xD8C5",
      handle: "shaktoolRoom",
      name: "Shaktool Room",
      area: 4,
      areaName: "Maridia",
      mapX: 28,
      mapY: 15,
      widthScreens: 4,
      heightScreens: 1,
    },
    {
      roomId: 55571,
      roomIdHex: "0xD913",
      handle: "halfieClimbRoom",
      name: "Halfie Climb Room",
      area: 4,
      areaName: "Maridia",
      mapX: 33,
      mapY: 6,
      widthScreens: 5,
      heightScreens: 3,
    },
    {
      roomId: 55646,
      roomIdHex: "0xD95E",
      handle: "botwoon",
      name: "Botwoon's Room",
      area: 4,
      areaName: "Maridia",
      mapX: 24,
      mapY: 8,
      widthScreens: 2,
      heightScreens: 1,
    },
    {
      roomId: 55722,
      roomIdHex: "0xD9AA",
      handle: "spaceJump",
      name: "Space Jump Room",
      area: 4,
      areaName: "Maridia",
      mapX: 38,
      mapY: 10,
      widthScreens: 1,
      heightScreens: 1,
    },
    {
      roomId: 55764,
      roomIdHex: "0xD9D4",
      handle: "maridiaHealthRefillRoom",
      name: "Maridia Health Refill Room",
      area: 4,
      areaName: "Maridia",
      mapX: 42,
      mapY: 6,
      widthScreens: 1,
      heightScreens: 1,
    },
    {
      roomId: 55806,
      roomIdHex: "0xD9FE",
      handle: "westCactusAlley",
      name: "West Cacattack Alley",
      area: 4,
      areaName: "Maridia",
      mapX: 27,
      mapY: 6,
      widthScreens: 1,
      heightScreens: 2,
    },
    {
      roomId: 55851,
      roomIdHex: "0xDA2B",
      handle: "eastCactusAlleyRoom",
      name: "East Cactus Alley Room",
      area: 4,
      areaName: "Maridia",
      mapX: 28,
      mapY: 6,
      widthScreens: 5,
      heightScreens: 2,
    },
    {
      roomId: 55904,
      roomIdHex: "0xDA60",
      handle: "draygon",
      name: "Draygon's Room",
      area: 4,
      areaName: "Maridia",
      mapX: 39,
      mapY: 9,
      widthScreens: 2,
      heightScreens: 2,
    },
    {
      roomId: 55982,
      roomIdHex: "0xDAAE",
      handle: "tourianElevator",
      name: "Tourian Elevator",
      area: 5,
      areaName: "Tourian",
      mapX: 20,
      mapY: 9,
      widthScreens: 1,
      heightScreens: 4,
    },
    {
      roomId: 56033,
      roomIdHex: "0xDAE1",
      handle: "metroidOne",
      name: "Metroid Room 1",
      area: 5,
      areaName: "Tourian",
      mapX: 14,
      mapY: 12,
      widthScreens: 6,
      heightScreens: 1,
    },
    {
      roomId: 56113,
      roomIdHex: "0xDB31",
      handle: "metroidTwo",
      name: "Metroid Room 2",
      area: 5,
      areaName: "Tourian",
      mapX: 13,
      mapY: 12,
      widthScreens: 1,
      heightScreens: 2,
    },
    {
      roomId: 56189,
      roomIdHex: "0xDB7D",
      handle: "metroidThree",
      name: "Metroid Room 3",
      area: 5,
      areaName: "Tourian",
      mapX: 14,
      mapY: 13,
      widthScreens: 6,
      heightScreens: 1,
    },
    {
      roomId: 56269,
      roomIdHex: "0xDBCD",
      handle: "metroidFour",
      name: "Metroid Room 4",
      area: 5,
      areaName: "Tourian",
      mapX: 20,
      mapY: 13,
      widthScreens: 1,
      heightScreens: 2,
    },
    {
      roomId: 56345,
      roomIdHex: "0xDC19",
      handle: "tourianHopper",
      name: "Tourian Hopper Room",
      area: 5,
      areaName: "Tourian",
      mapX: 19,
      mapY: 15,
      widthScreens: 2,
      heightScreens: 1,
    },
    {
      roomId: 56421,
      roomIdHex: "0xDC65",
      handle: "dustTorizo",
      name: "Dust Torizo Room",
      area: 5,
      areaName: "Tourian",
      mapX: 17,
      mapY: 15,
      widthScreens: 2,
      heightScreens: 1,
    },
    {
      roomId: 56497,
      roomIdHex: "0xDCB1",
      handle: "bigBoy",
      name: "Big Boy Room",
      area: 5,
      areaName: "Tourian",
      mapX: 13,
      mapY: 15,
      widthScreens: 4,
      heightScreens: 1,
    },
    {
      roomId: 56575,
      roomIdHex: "0xDCFF",
      handle: "seaweedRoom",
      name: "Seaweed Room",
      area: 5,
      areaName: "Tourian",
      mapX: 12,
      mapY: 15,
      widthScreens: 1,
      heightScreens: 2,
    },
    {
      roomId: 56622,
      roomIdHex: "0xDD2E",
      handle: "tourianRechargeRoom",
      name: "Tourian Recharge Room",
      area: 5,
      areaName: "Tourian",
      mapX: 11,
      mapY: 16,
      widthScreens: 1,
      heightScreens: 1,
    },
    {
      roomId: 56664,
      roomIdHex: "0xDD58",
      handle: "motherBrain",
      name: "Mother Brain's Room",
      area: 5,
      areaName: "Tourian",
      mapX: 13,
      mapY: 18,
      widthScreens: 4,
      heightScreens: 1,
    },
    {
      roomId: 56772,
      roomIdHex: "0xDDC4",
      handle: "tourianEyeDoor",
      name: "Tourian Eye Door Room",
      area: 5,
      areaName: "Tourian",
      mapX: 13,
      mapY: 16,
      widthScreens: 4,
      heightScreens: 1,
    },
    {
      roomId: 56819,
      roomIdHex: "0xDDF3",
      handle: "rinkaShaft",
      name: "Rinka Shaft",
      area: 5,
      areaName: "Tourian",
      mapX: 17,
      mapY: 16,
      widthScreens: 1,
      heightScreens: 3,
    },
    {
      roomId: 56867,
      roomIdHex: "0xDE23",
      handle: "lowerTourianSaveRoom",
      name: "Lower Tourian Save Room",
      area: 5,
      areaName: "Tourian",
      mapX: 16,
      mapY: 17,
      widthScreens: 1,
      heightScreens: 1,
    },
    {
      roomId: 56909,
      roomIdHex: "0xDE4D",
      handle: "tourianEscapeRoom1",
      name: "Tourian Escape Room 1",
      area: 5,
      areaName: "Tourian",
      mapX: 11,
      mapY: 18,
      widthScreens: 2,
      heightScreens: 1,
    },
    {
      roomId: 56954,
      roomIdHex: "0xDE7A",
      handle: "tourianEscapeRoom2",
      name: "Tourian Escape Room 2",
      area: 5,
      areaName: "Tourian",
      mapX: 11,
      mapY: 19,
      widthScreens: 1,
      heightScreens: 2,
    },
    {
      roomId: 56999,
      roomIdHex: "0xDEA7",
      handle: "tourianEscapeRoom3",
      name: "Tourian Escape Room 3",
      area: 5,
      areaName: "Tourian",
      mapX: 12,
      mapY: 19,
      widthScreens: 6,
      heightScreens: 2,
    },
    {
      roomId: 57054,
      roomIdHex: "0xDEDE",
      handle: "tourianEscape4",
      name: "Tourian Escape Room 4",
      area: 5,
      areaName: "Tourian",
      mapX: 18,
      mapY: 16,
      widthScreens: 3,
      heightScreens: 6,
    },
    {
      roomId: 57115,
      roomIdHex: "0xDF1B",
      handle: "upperTourianSaveRoom",
      name: "Upper Tourian Save Room",
      area: 5,
      areaName: "Tourian",
      mapX: 21,
      mapY: 12,
      widthScreens: 1,
      heightScreens: 1,
    },
    // {
    //   roomId: 57157,
    //   roomIdHex: "0xDF45",
    //   handle: "ceresElevator",
    //   name: "Ceres Elevator",
    //   area: 6,
    //   areaName: "Ceres",
    //   mapX: 12,
    //   mapY: 13,
    //   widthScreens: 1,
    //   heightScreens: 3,
    // },
    {
      roomId: 57229,
      roomIdHex: "0xDF8D",
      handle: "fallingTileRoom",
      name: "Falling Tile Room",
      area: 6,
      areaName: "Ceres",
      mapX: 13,
      mapY: 15,
      widthScreens: 2,
      heightScreens: 1,
    },
    {
      roomId: 57303,
      roomIdHex: "0xDFD7",
      handle: "magnetStairsRoom",
      name: "Magnet Stairs Room",
      area: 6,
      areaName: "Ceres",
      mapX: 15,
      mapY: 15,
      widthScreens: 1,
      heightScreens: 2,
    },
    {
      roomId: 57377,
      roomIdHex: "0xE021",
      handle: "deadScientistRoom",
      name: "Dead Scientist Room",
      area: 6,
      areaName: "Ceres",
      mapX: 16,
      mapY: 16,
      widthScreens: 2,
      heightScreens: 1,
    },
    {
      roomId: 57451,
      roomIdHex: "0xE06B",
      handle: "flatRoom",
      name: "Ceres Flat Room",
      area: 6,
      areaName: "Ceres",
      mapX: 18,
      mapY: 16,
      widthScreens: 2,
      heightScreens: 1,
    },
    // {
    //   roomId: 57525,
    //   roomIdHex: "0xE0B5",
    //   handle: "ceresRidley",
    //   name: "Ceres Ridley Room",
    //   area: 6,
    //   areaName: "Ceres",
    //   mapX: 20,
    //   mapY: 16,
    //   widthScreens: 1,
    //   heightScreens: 1,
    // },
  ];
}
